const Enum = () => {};

const ZeroToTen = {
  0: " Primeira",
  1: " Segunda",
  2: " Terceira",
  3: " Quarta",
  4: " Quinta",
  5: " Sexta",
  6: " Sétima",
  7: " Oitava",
  8: ' Nona',
  9: ' Décima'
};

const Ordinals = {
  0: 'Décima', 
  1: 'Vigésima', 
  2: 'Trigésima', 
  3: 'Quadragésima', 
  4: 'Quinquagésima', 
  5: 'Sextagésima', 
  6: 'Octagésima', 
  7: 'Nonagésima'
};

// EXPOSE ENUMS
Enum._ZeroToTen = ZeroToTen;
Enum._Ordinals = Ordinals;

export default Enum;
